<template>
  <div class="listleft">
    <el-menu :default-active="activeNames" :default-openeds="zhankaiNames" background-color="#fff" text-color="#0086e3" active-text-color="#fff">
      <Submenu :menuList="menu_List"></Submenu>
    </el-menu>
    <!-- <el-collapse v-for="(item,index) in menu_List" :key="index" v-model="activeNames">
          <div @click.stop="switchMenu(item)">
            <el-collapse-item :title="item.name" :name="item.id" >
              <div class="asideMenu" >
                <div v-for="(items,indexs) in item.subCates" :class='[items.id == form.cate_id ? refname : ""]' :key="indexs" @click.stop="switchMenu(items)">
                  <span class="iconfont icon-zuzhizhankai"></span>
                  {{items.name}}
                </div>
              </div>
            </el-collapse-item>
          </div>
        </el-collapse> -->
    <!-- <el-collapse accordion v-model="activelist" displag:none >
      <el-collapse-item title="赢在成都" :name="1">
        <div class="sfqitem" :class="{ active: $route.path === '/cdgk' }" @click="fn(100)">成都概况</div>
        <div class="sfqitem" :class="{ active: $route.path === '/fzhj' }" @click="fn(101)">发展环境</div>
        <div class="sfqitem" :class="{ active: $route.path === '/cycj' }" @click="fn(102)">产业成就</div>
      </el-collapse-item>
      <div
        class="leftitem"
        :class="{ active: $route.path === '/szyw' }"
        @click="fn(8)"
      >
        时政要闻
      </div>
      <div
        class="leftitem"
        :class="{ active: $route.path === '/hyez'}"
        @click="fn(9)"
      >
        行业资讯
      </div>
      <el-collapse-item @click="fn(10)" title="专题活动" :name="2">
        <div
          class="sfqitem"
          :class="{ active: $route.path === '/jqql' }"
          @click="fn(110)"
        >
          建圈强链
        </div>
        <div
          class="sfqitem"
          :class="{ active: $route.path === '/qlhd' }"
          @click="fn(111)"
        >
          20+系列活动
        </div>
      </el-collapse-item>
      <div
        class="leftitem"
        :class="{ active: $route.path === '/tzgg'}"
        @click="fn(11)"
      >
        通知公告
      </div>
      <el-collapse-item @click="fn(12)" title="产业政策" displag:none :name="3">
        <div class="sfqitem" :class="{ active: $route.path === '/gjj' }" @click="fn(2000)">国家级</div>
        <div class="sfqitem" :class="{ active: $route.path === '/scj' }" @click="fn(2001)">四川级</div>
        <div class="sfqitem" :class="{ active: $route.path === '/cdj' }" @click="fn(2002)">成都级</div>
      </el-collapse-item>
      <div
        class="leftitem"
        :class="{ active: $route.path === '/cydt' }"
        @click="fn(13)"
      >
        产业动态
      </div>
      <div
        class="leftitem"
        :class="{ active: $route.path === '/rjmc' }"
        @click="fn(14)"
      >
        软件名城
      </div>
      <el-collapse-item @click="fn(15)" title="产业服务" :name="4" displag:none>
        <div class="sfqitem" :class="{ active: $route.path === '/qyfw' }" @click="fn(120)">企业服务</div>
        <div class="sfqitem" :class="{ active: $route.path === '/hytj' }" @click="fn(121)">行业统计</div>
        <div class="sfqitem" :class="{ active: $route.path === '/rbrc' }" @click="fn(122)">蓉贝人才</div>
        <div class="sfqitem" :class="{ active: $route.path === '/rqh' }" @click="fn(123)">软洽会</div>
        <div class="sfqitem" :class="{ active: $route.path === '/rjds' }" @click="fn(124)">软件大赛</div>
        <div class="sfqitem" :class="{ active: $route.path === '/xxtxds' }" @click="fn(125)">信息通信大会</div>
      </el-collapse-item>
    </el-collapse> -->

    <!-- <el-row class="tac">
      <el-col :span="24">
        <el-menu
          unique-opened
          default-active="this.$route.query.id"
          default-openeds="[100,101,102]"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
        >
          <el-submenu index="100">
            <template slot="title">
              <span>赢在成都</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="cdgk" @click="fn(100)">成都概况</el-menu-item>
              <el-menu-item index="fzhj" @click="fn(101)">发展环境</el-menu-item>
              <el-menu-item index="cycj" @click="fn(102)">产业成就</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item index="8">
            <span slot="title" @click="fn(8)">时政要闻</span>
          </el-menu-item>
          <el-menu-item index="9">
            <span slot="title" @click="fn(9)">行业资讯</span>
          </el-menu-item>

          <el-submenu index="10">
            <template slot="title">
              <span @click="fn(10)">专题活动</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="4-1" @click="fn(110)">建圈强链</el-menu-item>
              <el-menu-item index="4-2" @click="fn(111)">20+系列活动</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item index="11">
            <span slot="title" @click="fn(11)">通知公告</span>
          </el-menu-item>

          <el-submenu index="12">
            <template slot="title">
              <span @click="fn(12)">产业政策</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="6-1" @click="fn(2000)">国家级</el-menu-item>
              <el-menu-item index="6-2" @click="fn(2001)">四川级</el-menu-item>
              <el-menu-item index="6-2" @click="fn(2002)">成都级</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item index="7">
            <span slot="title" @click="fn(13)">产业动态</span>
          </el-menu-item>
          <el-menu-item index="8">
            <span slot="title" @click="fn(14)">软件名城</span>
          </el-menu-item>

          <el-submenu index="9">
            <template slot="title">
              <span @click="fn(15)">专题活动</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1-1" @click="fn(120)">企业服务</el-menu-item>
              <el-menu-item index="1-1" @click="fn(121)">行业统计</el-menu-item>
              <el-menu-item index="1-1" @click="fn(122)">蓉贝人才</el-menu-item>
              <el-menu-item index="1-1" @click="fn(123)">软洽会</el-menu-item>
              <el-menu-item index="1-1" @click="fn(124)">软件大赛</el-menu-item>
              <el-menu-item index="1-1" @click="fn(125)">信息通信大会</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row> -->
  </div>
</template>
<script>
import Submenu from '@/views/submenu.vue'
import { MenuList } from "@/api/index.js";
export default {
  name: "listleft",
  data() {
    return {
      isactice: false,
      activelist: "",
      title: this.$route.query.title,
      menu_List:'',
      form: {
        siteid: 5,
        cate_id: '',
        online: 1,
        enabled: 1,
        english: 0,
        page: 1,
        limit: 15,
      },
      activeNames:'',
      zhankaiNames:[],
      refname:'zhankai',

    };
  },
  components: {
    Submenu
  },
  created() {
    this.getMenuList()
    let url = window.location.href
    if (url.indexOf("?") != -1) { //判断是否有参数
    this.form.cate_id = url.substr(1).split('?')[1].split('&')[0].split('=')[1]
      this.getList();
    this.zhankaiNames.push(this.form.cate_id)
      this.activeNames=this.form.cate_id
    }
    var num = parseInt(this.$route.query.id);
    if(num == 100 || num == 101 || num == 102 ){
      this.activelist=1;
    }
    if(num == 110 || num == 111 ){
      this.activelist=2;
    }
    if(num == 2000 || num == 2001 || num == 2002  ){
      this.activelist=3;
    }
    if(num == 120 || num == 121 || num == 122 || num == 123 || num == 124 || num == 125){
      this.activelist=4;
    }

    // this.activelist = num;
  },
  methods: {
    getMenuList() {
      MenuList({siteId:5}).then(res => {
        this.menu_List = res.data.data
      })
    },
    switchMenu(e) {
      let id = e.id
      this.form.cateid = e.id
      if(e.id == 100) {
        let url = this.$router.resolve({ path: "/cdgk", query: { id } });
        window.open(url.href,'_blank')
      }else if(e.id == 101) {
        let url = this.$router.resolve({ path: "/fzhj", query: { id } });
        window.open(url.href,'_blank')
      }else if(e.subCates == undefined || e.subCates.length == 0 ) {
        // 一级菜单直接跳转页面
        let goUrl = this.$router.resolve({path:'/details',query: {id:id}})
        window.open(goUrl.href,'_blank')
      }else{
      }
    },
    fn(id) {
      const obj = {
        8: "/szyw",
        9: "/hyez",
        11: "/tzgg",
        13: "/cydt",
        14: "/rjmc",

        10: "/zthd",
        12: "/cyzc",
        15: "/cyfw",

        2000: "/gjj",
        2001: "/scj",
        2002: "/cdj",
        100: "/cdgk",
        101: "/fzhj",
        102: "/cycj",
        110: "/jqql",
        111: "/qlhd",
        120: "/qyfw",
        121: "/hytj",
        122: "/rbrc",
        123: "/rqh",
        124: "/rjds",
        125: "/xxtxds",
      };
      this.$router.push({ path: obj[id], query: { id } });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="less">
.el-collapse-item {
  // padding-left: 15px;
  font-size: 14px !important;
}
.listleft {
  position: sticky;
  top: 70px;
  // width: 190px;
  margin-left: 15px;
  // border-bottom:1px solid #d4d8da;
}
// .el-collapse-item{
//   //  border:1px solid #d4d8da;
// }
.leftitem {
  height: 48px;
  line-height: 48px;
  // border:1px solid #d4d8da;
  padding-left: 15px;
  color: #303133;
  // margin-bottom: 15px;
  font-size: 16px;
  text-align: left;
  padding-left: 45px;
  background: #fff;
}
.leftitem:hover {
  background: #0086e3;
  color: #fff;
  cursor: pointer;
}
.sfqitem {
  height: 48px;
  line-height: 48px;
}
.el-collapse {
  border: 1px solid #ebeef5;
  // padding-left: 15px;
}
.el-collapse-item__header {
  font-size: 16px !important;
  padding-left: 30px;
  padding-left: 45px;
  // border: 1px solid #0086e3;
}
.el-collapse-item__header:hover {
  background: #0086e3;
  color: #fff;
}
.el-collapse-item__content{
  // border: 1px solid #0086e3;
  border-top: 0px;
  padding-bottom: 0px !important;
}
.sfqitem {
  height: 45px;
  line-height: 45px;
  padding-left: 45px;
  font-size: 14px;
  color: #303133;
  cursor: pointer;
  text-align: left;
}
.sfqitem:hover {
  display: block;
  background: #0086e3;
  padding-left: 45px;
  color: #fff;
  cursor: pointer;
}
.el-collapse-head-8120 {
  height: 48px;
  height: 48px;
  padding-left: 15px;
}
.active {
  background: #0086e3;
  color: #fff;
}
/deep/.el-collapse-item__arrow {
  display: none!important;
}
.asideMenu div {
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-left: 45px;
  cursor: pointer;
}
.asideMenu div:hover {
  background-color: #0086e3;
  color: #fff;
}
.el-collapse-item__header .el-icon-arrow-right {
  display: none!important;;
}
.zhankai {
  background-color:#0086e3!important;
  color: #fff!important;
}
.el-menu-item.is-active {
  background-color: #0086e3!important;
}
.el-menu-item {
  border-top: 1px solid #0086e3;
  border-left: 1px solid #0086e3;
  border-right: 1px solid #0086e3;
  // margin-bottom: 15px;
}
</style>
